// ./context/reducer/recognizedInstructorReducer.js

const recognizedInstructorReducer = (state, { type, payload }) => {
  switch (type) {
    case 'LOAD_INSTRUCTORS':
    case 'SET_INSTRUCTORS':
      return {
        ...state,
        instructors: payload,
        isLoading: false,
        error: null
      };

    case 'SET_CURRENT_INSTRUCTOR':
      return {
        ...state,
        currentInstructor: payload,
        isLoading: false,
        error: null
      };

    case 'ADD_INSTRUCTOR':
      console.log("add instructor reducer: ", payload);
      return {
        ...state,
        instructors: [...state.instructors, payload],
        currentInstructor: payload,
        isLoading: false,
        error: null
      };

    case 'UPDATE_INSTRUCTOR':
      return {
        ...state,
        instructors: state.instructors.map(instructor =>
          instructor.email === payload.email ? payload : instructor
        ),
        currentInstructor: state.currentInstructor?.email === payload.email 
          ? payload 
          : state.currentInstructor,
        isLoading: false,
        error: null
      };

    case 'DELETE_INSTRUCTOR':
      return {
        ...state,
        instructors: state.instructors.filter(
          instructor => instructor.email !== payload
        ),
        currentInstructor: state.currentInstructor?.email === payload 
          ? null 
          : state.currentInstructor,
        isLoading: false,
        error: null
      };

    case 'SET_LOADING':
      return {
        ...state,
        isLoading: payload
      };

    case 'SET_ERROR':
      return {
        ...state,
        error: payload,
        isLoading: false
      };

    case 'CLEAR_INSTRUCTOR_DATA':
      return {
        instructors: [],
        currentInstructor: null,
        isLoading: false,
        error: null
      };

    default:
      return state;
  }
};

export default recognizedInstructorReducer;